import { useState } from "react";
import { useEffect } from "react";
import { StrictMode } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import PreviewIcon from "@mui/icons-material/Preview";
import axios from "axios";

import constants from "../../assets/constants";
import * as AssessmentSessionActions from "../../state/redux/assessmentSession";
import AlertDialog from "../dialogs/alertDialog";
import AssessmentPreviewWizardDialog from "../dialogs/assessmentPreviewWizardDialog";
import OmniAssessmentTemplateListItem from "../ui/omniAssesmentTemplateListItem";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const AdminAssessmentTemplates = props => {
  const {
    assessmentTemplates,
    setAssessmentTemplateODMRequest,
    organizationODM,
    setAssessmentPaginationFocusRequest,
  } = props;

  const navigateToManagePortal = () => {
    let thePath = constants.appPaths.appPathAdminAssessment;
    props.history.push(thePath);
  };

  const [titleText, setTitleText] = useState(null);

  const filterAssessmentTemplates = () => {
    let assessmentsArray = [];

    if (assessmentTemplates != null) {
      assessmentsArray = assessmentTemplates.filter(assessment =>
        organizationODM.omniData.supportedAssessmentTypes.includes(assessment.omniData.omniType),
      );
    }

    // console.log(assessmentTemplates.length);
    // console.log(assessmentTemplates[20].omniData.omniType);
    return assessmentsArray;
  };

  // Remove this after demos are done
  const [myAssessmentTemplates, setMyAssessmentTemplates] = useState(null);

  useEffect(() => {
    if (myAssessmentTemplates != null) {
      setTitleText(
        `${Object.entries(myAssessmentTemplates).length} ${
          myAssessmentTemplates.length === 1 ? "Template" : "Templates"
        }`,
      );
    } else {
      setMyAssessmentTemplates(filterAssessmentTemplates());
    }
    // Disable eslint because AaronK knows best, fuck yea he does!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentTemplates, myAssessmentTemplates, setMyAssessmentTemplates]);

  useEffect(() => {
    if (assessmentTemplates == null) {
      props.loadAssessmentTemplatesRequest();
    } else {
      setMyAssessmentTemplates(filterAssessmentTemplates());
    }
    // Disable eslint because AaronK knows best, fuck yea he does!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentTemplates]);

  const [previewFile, setPreviewFile] = useState(null);
  const [assessmentODM, setAssessmentODM] = useState(null);
  const [previewFileError, setPreviewFileError] = useState(null);

  const handleFileSelected = e => {
    setPreviewFile(e.target.files[0]);
  };

  const isJson = str => {
    // Gotta make sure the File contains JSON
    // If it's an object let's assume it's good
    if (typeof str !== "object" && str !== null) {
      try {
        JSON.parse(str);
        console.log(`Sucessfully Parsed JSON`);
      } catch (e) {
        console.log(`Error Parsing JSON: ${e}`);
        setPreviewFileError(e.message);
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (previewFile != null) {
      axios
        .get(window.URL.createObjectURL(previewFile))
        .then(res => (isJson(res.data) ? setAssessmentODM(res.data) : setAssessmentODM(null)))
        .catch(err => console.log(err));
    } else {
      setAssessmentODM(null);
    }
    // Disable eslint because AaronK knows best, fuck yea he does!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewFile]);

  useEffect(() => {
    if (assessmentODM != null) {
      console.log(`Assessment is not null: ${assessmentODM}`);
    } else {
      console.log(`Assessment is null`);
    }
    // Disable eslint because AaronK knows best, fuck yea he does!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentODM]);

  return (
    <Widget>
      <StrictMode>
        <WidgetTitle
          title={"ASSESSMENT TEMPLATES"}
          text={titleText}
          loading={myAssessmentTemplates == null}
        >
          <OmniResponsiveButton
            tooltipTitle="Preview Assessment Template"
            buttonText="Preview"
            component="label"
            icon={<PreviewIcon />}
          >
            <input
              disabled={previewFile}
              type={"file"}
              id={"previewAssessmentInput"}
              accept={".json"}
              hidden={true}
              onClick={e => {
                e.target.value = null;
              }}
              onChange={handleFileSelected}
            />
          </OmniResponsiveButton>
        </WidgetTitle>

        {myAssessmentTemplates == null && <WidgetSkeleton />}

        {myAssessmentTemplates != null && (
          <WidgetList>
            {myAssessmentTemplates.map((assesmentTemplateODM, index) => {
              return (
                <OmniAssessmentTemplateListItem
                  key={`AdminCommunicationTemplates-${index}`}
                  assessmentTemplateDef={assesmentTemplateODM}
                  onClickHandler={() => {
                    setAssessmentPaginationFocusRequest(assesmentTemplateODM.omniData.omniType);
                    setAssessmentTemplateODMRequest(assesmentTemplateODM);
                    navigateToManagePortal();
                  }}
                  isTypeSupported={
                    organizationODM &&
                    organizationODM.omniData.supportedAssessmentTypes.includes(
                      assesmentTemplateODM.omniData.omniType,
                    )
                  }
                />
              );
            })}
          </WidgetList>
        )}
        {assessmentODM && previewFile && (
          <AssessmentPreviewWizardDialog
            open={assessmentODM != null}
            previewAssessmentODM={assessmentODM}
            onClose={() => {
              setPreviewFile(null);
            }}
          />
        )}
        {previewFileError && (
          <AlertDialog
            open={previewFileError}
            dialogMessage={previewFileError}
            dialogTitle={`JSON Parsing Error`}
            cancelMessage={""}
            onAccept={() => {
              setPreviewFileError(null);
              setPreviewFile(null);
            }}
            onClose={() => {
              setPreviewFileError(null);
              setPreviewFile(null);
            }}
          />
        )}
      </StrictMode>
    </Widget>
  );
};
const mapStateToProps = state => ({
  assessmentTemplates: state.assessmentSession.assessmentTemplates,
  selectedAssessmentTemplateODM: state.assessmentSession.assessmentTemplateODM,

  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  setAssessmentTemplateODMRequest: AssessmentSessionActions.setAssessmentTemplateODMRequest,
  setAssessmentPaginationFocusRequest: AssessmentSessionActions.setAssessmentPaginationFocusRequest,
  loadAssessmentTemplatesRequest: AssessmentSessionActions.loadAssessmentTemplatesRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminAssessmentTemplates));
